<app-attendee-layout *ngIf="!hasOrganizer" class="reviews-page">
  <header class="reviews-page__header">
    <app-back-link
      class="reviews-page__back-link"
      [ariaLabel]="'a11y.attendee.activity_detail.back_link' | translate"
      [backLink]="backLink"
    ></app-back-link>
    <h1 class="reviews-page__title">
      {{ 'attendee.reviews.title' | translate }}
    </h1>
  </header>
  <section *ngIf="hasResults" class="reviews-page__container">
    <div class="reviews-page__summary">
      <div class="reviews-page__summary-global">
        <h2 class="reviews-page__summary-global-count">
          {{ reviewsTranslation }}
        </h2>
        <app-vtmn-rating
          [emphasis]="true"
          [showValue]="true"
          [value]="averageRating"
          [size]="ratingSize.SMALL"
        ></app-vtmn-rating>
        <p class="reviews-page__summary-ratio">
          <vtmn-play-icon
            class="reviews-page__thumb-icon"
            [name]="iconType?.Check"
          ></vtmn-play-icon>
          {{ recommendationRate | percent }} {{ 'reviews.text' | translate }}
        </p>
        <div class="reviews-page__summary-ratio-lg">
          <p
            *ngFor="let item of ratingDistribution"
            class="reviews-page__summary-ratio-lg-block"
          >
            <span class="reviews-page__summary-ratio-lg-code">
              {{
                item.code !== '1'
                  ? ('reviews.stars' | translate: { numberOfStars: item.code })
                  : ('reviews.star' | translate: { numberOfStars: item.code })
              }}
            </span>
            <span class="reviews-page__summary-ratio-lg-rate">{{
              item.rate | percent
            }}</span>
            <span class="reviews-page__summary-ratio-lg-line-block">
              <span
                class="reviews-page__summary-ratio-lg-line"
                [ngStyle]="{ width: cssStyle(item.rate | percent) }"
              ></span>
            </span>
          </p>
        </div>
      </div>
      <h2 class="reviews-page__summary-detail">
        {{ 'reviews.detail' | translate }}
      </h2>
      <ul class="reviews-page__summary-items">
        <li
          class="reviews-page__summary-item"
          *ngFor="let item of averageAttributeRating"
        >
          {{ item.label }}
          <app-vtmn-rating
            [compact]="true"
            [emphasis]="true"
            [showValue]="true"
            [value]="item.value"
            [size]="ratingSize.SMALL"
          ></app-vtmn-rating>
        </li>
      </ul>
    </div>
    <div class="reviews-page__details">
      <ul>
        <li *ngFor="let review of reviews" class="reviews-page__details-item">
          <app-activity-reviews-detail
            [review]="review"
            [isReviewsPage]="true"
          ></app-activity-reviews-detail>
        </li>
      </ul>
      <app-pagination-buttons
        *ngIf="reviewCount > 5"
        [hasLoadMoreButton]="hasLoadMoreButton"
        [reviewsLabel]="true"
        (loadMore)="getReviews(activityId, reviewsParams)"
        class="block mt-6"
      >
      </app-pagination-buttons>
    </div>
  </section>
  <section *ngIf="!isLoading && reviewCount === 0">
    <app-tips
      class="block mt-4"
      [title]="'reviews.no_reviews_text' | translate"
      [icon]="iconType.Information"
      [variant]="tipsVariant.WARNING"
      [displayArrowIcon]="false"
    ></app-tips>
  </section>
  <div class="spinner mx-auto my-8" *ngIf="isLoading"></div>
</app-attendee-layout>

<div *ngIf="hasOrganizer" class="reviews-page-organiser">
  <section *ngIf="hasResults" class="reviews-page-organiser__container">
    <div class="reviews-page-organiser__summary">
      <div>
        <span class="reviews-page-organiser__summary-rating">
          {{ averageRating | number: '1.0-1' : 'en' }}
        </span>
        <app-vtmn-rating
          class="reviews-page-organiser__summary-rating-stars"
          [emphasis]="true"
          [showValue]="false"
          [value]="averageRating"
          [size]="ratingSize.SMALL"
        ></app-vtmn-rating>
        <div class="reviews-page-organiser__summary-ratio-lg">
          <p
            *ngFor="let item of ratingDistribution"
            class="reviews-page-organiser__summary-ratio-lg-block"
          >
            <span class="reviews-page-organiser__summary-ratio-lg-code">
              {{
                item.code !== '1'
                  ? ('reviews.stars' | translate: { numberOfStars: item.code })
                  : ('reviews.star' | translate: { numberOfStars: item.code })
              }}
            </span>
            <span class="reviews-page-organiser__summary-ratio-lg-rate">{{
              item.rate | percent
            }}</span>
            <span class="reviews-page-organiser__summary-ratio-lg-line-block">
              <span
                class="reviews-page-organiser__summary-ratio-lg-line"
                [ngStyle]="{ width: cssStyle(item.rate | percent) }"
              ></span>
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="reviews-page-organiser__details">
      <h2 class="reviews-page-organiser__details-global-count">
        {{ reviewsTranslation }}
      </h2>
      <app-divider
        class="reviews-page-organiser__divider"
        color="light-2"
      ></app-divider>
      <ul *ngIf="organizerReviews">
        <li
          *ngFor="let review of organizerReviews"
          class="reviews-page-organiser__details-item"
        >
          <app-activity-reviews-detail
            [review]="review"
            [isReviewsPage]="true"
            [activityMedia]="activityMedia"
            [activityName]="activityName"
          ></app-activity-reviews-detail>
        </li>
      </ul>
      <app-pagination-buttons
        *ngIf="reviewCount > 5 && hasLoadMoreButton !== undefined"
        [hasLoadMoreButton]="hasLoadMoreButton"
        [loaderKey]="organizerReviewsLoaderKey"
        [reviewsLabel]="true"
        (loadMore)="getOrganizationReviews(organizerId, reviewsParams)"
        class="block mt-6"
      >
      </app-pagination-buttons>
    </div>
  </section>
  <section *ngIf="!hasResults && !hasApiError && !isLoading">
    <app-tips
      class="block mt-4"
      [title]="'reviews.no_reviews_text' | translate"
      [icon]="iconType.Information"
      [variant]="tipsVariant.WARNING"
      [displayArrowIcon]="false"
    ></app-tips>
  </section>
  <section *ngIf="hasApiError && !isLoading">
    <app-tips
      class="block mt-4"
      [title]="'reviews.api_error' | translate"
      [icon]="iconType.Information"
      [variant]="tipsVariant.DANGER"
      [displayArrowIcon]="false"
    ></app-tips>
  </section>
  <div class="spinner mx-auto my-8" *ngIf="isLoading"></div>
</div>
